var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "22px",
    viewBox: "0 0 29 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(3.000000, 0.000000)",
    fill: "#645A5B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0212183,7.99932535 L15.4743253,7.99932535 L15.4743253,2.97612611 C15.4743253,2.818363 15.4116357,2.66683325 15.3001684,2.55536071 C15.1884886,2.44368092 15.0371661,2.38099654 14.8791958,2.38099654 L7.73713079,2.38099654 C7.40832478,2.38099654 7.14201185,2.64752736 7.14201185,2.97611549 L7.14201185,11.1597316 L0.595118942,11.1597316 C0.266520184,11.1597316 6.79652999e-14,11.4262624 6.79652999e-14,11.7548506 L6.79652999e-14,20.5336388 C6.79652999e-14,20.6914019 0.062689688,20.8427244 0.174364164,20.9544042 C0.286043954,21.066084 0.437366456,21.1287683 0.59512957,21.1287683 L22.0213245,21.1287683 C22.1790876,21.1287683 22.3304102,21.0660787 22.4420899,20.9544042 C22.5537697,20.8427244 22.6164541,20.6914019 22.6164541,20.5336388 L22.6164541,8.59459308 C22.6164541,8.43662272 22.5537644,8.28530022 22.4420899,8.17362043 C22.3304102,8.06194064 22.1790876,7.99925627 22.0213245,7.99925627 L22.0212183,7.99932535 Z M7.1419162,19.938371 L1.19019537,19.938371 L1.19019537,12.349927 L7.1419162,12.349927 L7.1419162,19.938371 Z M14.2839812,8.59449743 L14.2839812,19.938371 L8.33226036,19.938371 L8.33226036,3.57113877 L14.2839812,3.57113877 L14.2839812,8.59449743 Z M21.4260462,19.938371 L15.4743253,19.938371 L15.4743253,9.18966951 L21.4260462,9.18966951 L21.4260462,19.938371 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73708828,1.19045045 L14.8791533,1.19045045 C15.2079593,1.19045045 15.4742722,0.923919633 15.4742722,0.595118942 C15.4742722,0.266520184 15.2079486,4.9463635e-14 14.8791533,4.9463635e-14 L7.73708828,4.9463635e-14 C7.40828227,4.9463635e-14 7.14196934,0.266530812 7.14196934,0.595118942 C7.14196934,0.923924947 7.4082929,1.19045045 7.73708828,1.19045045 L7.73708828,1.19045045 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeaderboard);
export default __webpack_public_path__ + "static/media/ic-leaderboard.0479642b950deb3a0014fd99de45c76b.svg";
export { ForwardRef as ReactComponent };